export default {

    data() {
        return {
            smallDeviceBreakPoint: 1200,
            allowScrollIn: [],
            totalSteps: 5,
            currentStep: 1,
            completed: {},
        }
    },

    created() {
        for (var i = 1; i <= this.totalSteps; i++) {
            this.completed['step_' + i] = false;
        }
        this.fireStepChangedEvent(1)
        eventBus.$on('change-nav-step', step => {
            this.changeStep(step)
        })
        window.addEventListener('resize', this.setFormHeight);
        this.setFormHeight();
    },

    methods: {
        changeStep(step) {
            $('body').removeClass(`multistep--${this.currentStep}`).addClass(`multistep--${step}`);
            this.enableScrollOn(step)
            this.currentStep = step
            this.fireStepChangedEvent(step)
        },

        fireStepChangedEvent(step) {
            eventBus.$emit('step-change', {
                step: step,
                completed: this.completed
            })
        },

        enableScrollOn(step) {
            window.scrollTo({top: 0, behavior: 'smooth'});

            let height = window.innerHeight
            if (height < this.smallDeviceBreakPoint) {
                // Don do this on small devices, allow scroll.
                return
            }

            if (this.allowScrollIn.includes(step)) {
                $('body').removeClass(`no-scroll`);
                return;
            }

            if (!$('body').hasClass('no-scroll')) {
                $('body').addClass(`no-scroll`);
            }
        },

        setStepCompleted(step) {
            this.completed['step_' + step] = true
        },

        // Set the website hight so we keep the form centered.
        setFormHeight() {
            let height = window.innerHeight
            document.documentElement.style.setProperty('--app-height', `${height}px`)

            if (height < this.smallDeviceBreakPoint) {
                if ($('body').hasClass('no-scroll')) {
                    $('body').removeClass(`no-scroll`);
                }
            } else {
                if (!$('body').hasClass('no-scroll')) {
                    $('body').addClass(`no-scroll`);
                }
            }

        },

        handleEnterKey() {
            $(document).on('keypress', event => {
                if (event.which == 13) {
                    var steps = {
                        1: 'saveStepOne',
                        2: 'saveStepTwo',
                        3: 'saveStepThree',
                        4: 'saveStepFour',
                        5: 'saveStepFive',
                    }
                    this[steps[this.currentStep]]()
                    event.preventDefault()
                    console.log('Pressed Enter')
                }
            });
        }
    }
}
